import fortran from "refractor/fortran";
export default fortran;